import lazyLoading from './lazyLoading'

export default {
  path: '/billing',
  system: 'business_sites',
  meta: {
    auth: true,
    icon: 'wallet',
    label: 'Billing'
  },
  component: lazyLoading('billing', true),
  children: [{
    name: 'Billing',
    path: '/billing',
    hidden: true,
    system: 'business_sites',
    meta: {
      link: 'billing/index.vue',
      label: 'Billing'
    },
    component: lazyLoading('billing/Info')
  }, {
    path: '/billing/cancel',
    name: 'CancelSubscription',
    hidden: true,
    meta: {
      label: '',
    },
    component: lazyLoading('billing/cancel', true),
  }, {
    path: '/billing/cancel/final',
    name: 'CancelSubscriptionFinal',
    hidden: true,
    meta: {
      label: '',
    },
    component: lazyLoading('billing/cancel/Final'),
  }, {
    path: '/billing/cancel/survey',
    name: 'CancelSubscriptionSurvey',
    hidden: true,
    meta: {
      label: '',
    },
    component: lazyLoading('billing/cancel/Survey'),
  }]
}
